import React, { Dispatch, FC, useEffect, useState } from 'react';
import classes from './accessBlock.module.scss';
import { ReactComponent as Exit } from '../../assets/images/newClose.svg';
import {
  useAnalytics,
  useOrganization,
  useStaff,
  useStatus,
} from '../../hooks/entityHooks';
import { UpdateEntity, UpdateEntityArray } from '../../Pages/OrgStructure';
import { TreeAccessView } from './TreeAccessView';
import { TypeModalWindow } from '../../types/utils/constants';
import { Tree } from './Tree';

type Config = {
  state: boolean;
  type: number;
};

interface IAccessBlock {
  id: number;
  setConfig: Dispatch<Config>;
  config: Config;
}

const AccessBlock: FC<IAccessBlock> = ({ id, setConfig, config }) => {
  const { getEntityList, entityList } = useOrganization();
  const [showOrganization, setShowOrganization] = useState<boolean>(false);
  const { getEntity: getStaff, entity: info } = useStaff();
  const [isChecked, setChecked] = useState<boolean>(false);

  useEffect(() => {
    getEntityList();
    getStaff(id);
  }, []);

  useEffect(() => {
    if (info) {
      setChecked(info.analyticsAccess);
    }
  }, [info]);

  const orgArr = entityList;
  const [clicked, setClicked] = useState<number[]>([]);

  const [entityLoader, setEntityLoader] = useState(false);

  const handleSetEntityLoader = (val: boolean) => {
    setEntityLoader(val);
  };
  const handleSetEntityUpdateArray = ({ getTree, id, type }: UpdateEntity) => {
    const newArray = updateEntityArray;
    if (!newArray.find((el) => el.id === id && el.type === type)) {
      newArray.push({ id, getTree, type });
    }

    setUpdateEntityArray(newArray);
  };

  const [updateEntityArray, setUpdateEntityArray] = useState<UpdateEntityArray>(
    [],
  );

  const { getAccessEmployee, accessList } = useAnalytics();
  const { changeAnalyticsAccess } = useStatus();

  useEffect(() => {
    if (id && orgArr) getAccessEmployee(id);
  }, [id]);

  const handleChangeAccess = () => {
    getAccessEmployee(id);
  };
  return (
    info && (
      <>
        <div className={classes.container}>
          <div className={classes.container__title}>
            <p>Доступ к аналитике</p>
            <Exit
              onClick={() => {
                document.body.style.overflowY = 'auto';
                setConfig({
                  type: TypeModalWindow.ORGANIZATION_DIALOG,
                  state: false,
                });
              }}
            />
          </div>
          <div className={classes.accessAnalytic}>
            <div className={classes.checkbox}>
              <input
                type="checkbox"
                id={`id-${id}`}
                checked={isChecked}
                onChange={() => {
                  changeAnalyticsAccess(info.id, !isChecked).then(() =>
                    setChecked(!isChecked),
                  );
                }}
              />
              <label htmlFor={`id-${id}`}>
                <span />
                Доступ в аналитику
              </label>
            </div>
          </div>
          <div
            className={`${classes.container__content} ${
              !isChecked && classes.blur
            }`}
          >
            <div className={classes.container__content__header}>
              <p style={{ marginBottom: 8, marginTop: 0 }}>
                У данного сотрудника имеется доступ ко следующим организациям и
                подразделениям:
              </p>
              {accessList.organizations.map((item) => {
                return (
                  <p className={classes.nameRow}>
                    <span className={classes.organization}>{item.name};</span>
                  </p>
                );
              })}
              {accessList.subdivisions.map((subdivision) => {
                return (
                  <p className={classes.nameRow}>
                    <span className={classes.organization}>
                      {`${subdivision.organization.name}: `}
                    </span>
                    {`${subdivision.name};`}
                  </p>
                );
              })}
            </div>
            <div className={classes.container__content__body}>
              <Tree
                idEmployee={id}
                handleSetEntityLoader={handleSetEntityLoader}
              />
            </div>
          </div>
        </div>
      </>
    )
  );
};

export default AccessBlock;
